<template>
    <div class="grid grid-cols-2 md:grid-cols-4 gap-2 w-full max-w-5xl">
        <NavCard v-for="site in sites" :key="site.name" v-bind="site" @click="handleCardClick(site)" />

        <SideDrawer :is-open="isDrawerOpen" :title="activeTool?.name" @close="handleClose">
            <component :is="activeComponent" v-if="activeComponent" ref="toolRef" />
        </SideDrawer>
    </div>
</template>

<script setup>
import { computed, ref, defineAsyncComponent } from 'vue';
import NavCard from './NavCard.vue';
import SideDrawer from './SideDrawer.vue';
import { NAV_SITES } from '../config/navData';

const sites = ref(NAV_SITES);
const isDrawerOpen = ref(false);
const activeTool = ref(null);

const toolRef = ref(null);

// 异步加载工具内容，避免初始包体积过大
const toolComponents = {
    timestamp: defineAsyncComponent(() => import('./tools/TimestampTool.vue')),
    'json-format': defineAsyncComponent(() => import('./tools/JsonTool.vue')),
    'random-gen': defineAsyncComponent(() => import('./tools/GeneratorTool.vue')),
    'crypto-tool': defineAsyncComponent(() => import('./tools/CryptoTool.vue')),
    'rich-editor': defineAsyncComponent(() => import('./tools/RichEditor.vue')),
    'qrcode-generator': defineAsyncComponent(() => import('./tools/QrCodeTool.vue'))
};

const activeComponent = computed(() => toolComponents[activeTool.value?.toolId] || null);


const handleClose = (source) => {
    if (source === 'button') {
        if (toolRef.value && typeof toolRef.value.clearAll === 'function') {
            toolRef.value.clearAll();
        }
    }
    // 无论是哪种方式，都关闭抽屉
    isDrawerOpen.value = false;
};

const handleCardClick = (item) => {
    if (item.type === 'link') {
        window.open(item.url, '_blank', 'noopener,noreferrer');
    } else if (item.type === 'tool') {
        activeTool.value = item;
        // toolRef.value = item.ref
        isDrawerOpen.value = true;
    }
};

</script>
